/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitTag,
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';
import {
    PressKitThumbnailUrls,
    PressKitThumbnailUrlsFromJSON,
    PressKitThumbnailUrlsFromJSONTyped,
    PressKitThumbnailUrlsToJSON,
} from './PressKitThumbnailUrls';

/**
 * 一覧表示されるガイドラインのファイル
 * @export
 * @interface PressKitGuidelinesResultsFiles
 */
export interface PressKitGuidelinesResultsFiles {
    /**
     * PressKit Guideline UUID(v4)
     * @type {string}
     * @memberof PressKitGuidelinesResultsFiles
     */
    id: string;
    /**
     * 企業が登録したファイルの名前（キャプション）
     * @type {string}
     * @memberof PressKitGuidelinesResultsFiles
     */
    title: string;
    /**
     * 企業が登録したファイル名
     * @type {string}
     * @memberof PressKitGuidelinesResultsFiles
     */
    filename: string;
    /**
     * ファイルのサイズ(バイト
     * @type {number}
     * @memberof PressKitGuidelinesResultsFiles
     */
    fileSize: number;
    /**
     * ファイル拡張子（原則英語小文字）
     * @type {string}
     * @memberof PressKitGuidelinesResultsFiles
     */
    extension: PressKitGuidelinesResultsFilesExtensionEnum;
    /**
     * 
     * @type {PressKitThumbnailUrls}
     * @memberof PressKitGuidelinesResultsFiles
     */
    thumbnailUrls: PressKitThumbnailUrls;
    /**
     * ガイドラインのファイルへ直接アクセスできるURL
     * @type {string}
     * @memberof PressKitGuidelinesResultsFiles
     */
    downloadUrl: string;
    /**
     * 企業が設定しているタグの一覧
     * @type {Array<PressKitTag>}
     * @memberof PressKitGuidelinesResultsFiles
     */
    readonly tags: Array<PressKitTag>;
}

/**
* @export
* @enum {string}
*/
export enum PressKitGuidelinesResultsFilesExtensionEnum {
    Pdf = 'pdf'
}

export function PressKitGuidelinesResultsFilesFromJSON(json: any): PressKitGuidelinesResultsFiles {
    return PressKitGuidelinesResultsFilesFromJSONTyped(json, false);
}

export function PressKitGuidelinesResultsFilesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitGuidelinesResultsFiles {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'filename': json['filename'],
        'fileSize': json['file_size'],
        'extension': json['extension'],
        'thumbnailUrls': PressKitThumbnailUrlsFromJSON(json['thumbnail_urls']),
        'downloadUrl': json['download_url'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PressKitGuidelinesResultsFilesToJSON(value?: PressKitGuidelinesResultsFiles | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'filename': value.filename,
        'file_size': value.fileSize,
        'extension': value.extension,
        'thumbnail_urls': PressKitThumbnailUrlsToJSON(value.thumbnailUrls),
        'download_url': value.downloadUrl,
    };
}

